module.exports = __webpack_public_path__ + "img/20190528161921QQ截图20190527165223.685d0c3b.png";